<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-17 15:16:17
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-08-01 14:00:46
 * @FilePath: /wemeet-poster/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/systemLog/operationLog/index.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->

<template>
  <div class="roleManagement-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.native.prevent>
          <el-form-item label="操作人账号:">
            <el-input v-model.trim="queryForm.likeOperationName" clearable placeholder="请输入操作人姓名" />
          </el-form-item>
          <el-form-item label="类型:">
            <el-select v-model="queryForm.type" clearable>
              <el-option v-for="item in operateTypelist" :key="item.id" :label="item.value" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText">
      <el-table-column label="操作id" prop="bizId" show-overflow-tooltip />
      <el-table-column label="操作信息" prop="msg" show-overflow-tooltip width="600" />

      <el-table-column label="操作时间" show-overflow-tooltip>
        <template #default="{ row }">
          {{ handleDate(row.operationDate) }}
        </template>
      </el-table-column>
      <el-table-column label="操作人姓名" prop="operatorName" show-overflow-tooltip />
      <el-table-column label="状态" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-if="row.operationStatus == 1" type="success">操作成功</el-tag>
          <el-tag v-else type="danger">操作失败</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
  import { defineComponent, onMounted, reactive, toRefs } from 'vue'
  import { getOperationLog, getOperationTypeList } from '@/api/systemLog'
  import { Search } from '@element-plus/icons'
  import { parseTime } from '@/utils/index'

  export default defineComponent({
    name: 'SystemLog',
    setup() {
      const state = reactive({
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        queryForm: {
          likeOperationName: '',
          type: '',
          pageNum: 1,
          pageSize: 20,
        },
        operateTypelist: [],
      })

      const fetchData = async () => {
        state.listLoading = true
        const {
          data: { list, total },
        } = await getOperationLog(state.queryForm)
        state.list = list
        state.total = total
        state.listLoading = false
        getTypeList()
      }

      const getTypeList = async () => {
        const { data } = await getOperationTypeList()
        let typeList = []
        for (let i in data) {
          let obj = {
            id: Number(i) + 1,
            value: data[i],
          }
          typeList.push(obj)
        }
        state.operateTypelist = typeList
        console.log(typeList)
      }
      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }
      const queryData = () => {
        state.queryForm.pageNum = 1
        fetchData()
      }
      onMounted(() => {
        fetchData()
      })
      const handleDate = (val) => {
        return parseTime(val)
      }

      return {
        ...toRefs(state),
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        queryData,
        Search,
        getTypeList,
        handleDate,
      }
    },
  })
</script>
